<template>
    <div class="w-100">
        <header
            class="w-100 text-uppercase font-weight-bold text-white px-2 my-3 d-flex justify-content-start align-items-center"
            style="background-color: #323337;"
        >
            <img
                class="profile-image-round mr-3"
                data-private
                :src="patient.profile_photo_url || '../../images/default_user.jpeg'"
                v-tooltip="patient.name"
            />
            <h4 class="mb-0" data-private="lipsum">{{ patient.name }}</h4>
            <i
                class="fa fa-2x fa-times cursor-pointer ml-auto"
                v-tooltip="'Remove from tracker'"
                @click="$emit('remove-patient', patient.id)"
            ></i>
        </header>
        <slot></slot>
        <div class="row pt-2 mr-0" v-if="patient.allGoals">
            <transition-group :name="'fade'" tag="div" class="transition-list">
                <div
                    v-for="g in patient.allGoals.filter(
                        a => patient.selectedGoals.includes(a.id) && a.domain.name === 'Behavior'
                    )"
                    :key="g.id"
                    class="col-12 col-sm-6 col-lg-4 list-inline-item mx-0 px-0"
                >
                    <div class="d-flex justify-content-center">
                        <live
                            :goal="g"
                            :date="date"
                            :customization="customizations.find(c => c.type === g.tracker_type)"
                            @goal-detail="$emit('goal-detail', $event)"
                            @close-tracker="closeTrackerAndCheckIfLast($event, g)"
                        ></live>
                    </div>
                </div>
                <div
                    v-for="g in patient.allGoals.filter(
                        a => patient.selectedGoals.includes(a.id) && a.domain.name !== 'Behavior'
                    )"
                    :key="g.id"
                    class="col-12 col-sm-6 col-lg-4 list-inline-item mx-0 px-0"
                >
                    <div class="d-flex justify-content-center">
                        <live
                            :goal="g"
                            :date="date"
                            :customization="customizations.find(c => c.type === g.tracker_type)"
                            @goal-detail="$emit('goal-detail', $event)"
                            @close-tracker="closeTrackerAndCheckIfLast($event, g)"
                        ></live>
                    </div>
                </div>
                <div
                    :key="'soap'"
                    v-if="showSoapNote"
                    class="col-12 col-sm-6 col-lg-4 list-inline-item mr-0 pl-0"
                >
                    <div class="d-flex justify-content-center">
                        <tracker-soap
                            :date="date"
                            :patient-id="patient.id"
                            :customization="customizations.find(c => c.type === 'soap_note')"
                            :session-goals="goalsTracked"
                            :session-notes="sessionNotes"
                            :user="user"
                            @close-soap="closeSoap()"
                        ></tracker-soap>
                    </div>
                </div>
            </transition-group>
        </div>
    </div>
</template>

<script>
import Live from "./TrackerLive";
import TrackerSoap from "./TrackerSoap";

export default {
    name: "SessionPatient",
    props: ["patient", "fade", "date", "user", "organization", "customizations"],
    components: {
        Live,
        TrackerSoap,
    },
    data() {
        return {
            sessionTrackersCount: 0,
            showSoapNote: false,
            sessionNotes: "",
            savedGoals: [],
        };
    },
    created() {
        this.$bus.$on("started-tracking", payload => {
            if (payload === this.patient.id) {
                this.sessionTrackersCount = this.patient.selectedGoals.length;
            }
        });
    },
    computed: {
        goalsTracked() {
            const goalsTracked = _.get(this.patient, "allGoals", []).filter(goal =>
                this.savedGoals.includes(goal.id)
            );
            return goalsTracked.map(({ id, title, description }) => ({ id, title, description }));
        },
    },
    methods: {
        closeTrackerAndCheckIfLast(note, goal) {
            if (note) {
                // Note is received only when the goal is saved.
                this.savedGoals.push(goal.id);
            }
            this.sessionNotes += note ? note + "; " : "";
            this.$emit("close-tracker", [this.patient.id, goal.id]);
            const soapNoteCustomization = this.customizations.find(c => c.type === "soap_note");
            if (this.patient.selectedGoals.length <= 1) {
                if (!soapNoteCustomization || soapNoteCustomization.is_active) {
                    this.showSoapNote = true;
                }
            }
        },

        closeSoap() {
            if (!this.$parent.patients.length) {
                window.onbeforeunload = null;
            }
            this.showSoapNote = false;
        },
    },
};
</script>
<style scoped lang="scss">
.transition-list {
    width: 100% !important;
}
.profile-image-round {
    min-width: 3rem;
    max-width: 3rem;
    min-height: 3rem;
    max-height: 3rem;
    border-radius: 50%;
}
</style>
